/*eslint no-unused-vars:0 */
/*eslint no-redeclare:0 */
/* tslint:disable */
var EPSILON = Math.pow(2, -52);

function __Mash() {
  this.n = 0xefc8249d;
}
__Mash.prototype.mash = function (data) {
  data = data.toString();
  var n = this.n;
  for (var i = 0; i < data.length; i++) {
    n += data.charCodeAt(i);
    var h = 0.02519603282416938 * n;
    n = h >>> 0;
    h -= n;
    h *= n;
    n = h >>> 0;
    h -= n;
    n += h * 0x100000000; // 2^32
  }
  this.n = n;
  return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
};

function __Alea(seed) {
  var mash = new __Mash();

  // Apply the seeding algorithm from Baagoe.
  var s0 = mash.mash(" ");
  var s1 = mash.mash(" ");
  var s2 = mash.mash(" ");
  s0 -= mash.mash(seed);
  if (s0 < 0) {
    s0 += 1;
  }
  s1 -= mash.mash(seed);
  if (s1 < 0) {
    s1 += 1;
  }
  s2 -= mash.mash(seed);
  if (s2 < 0) {
    s2 += 1;
  }

  this.c = 1;
  this.s0 = s0;
  this.s1 = s1;
  this.s2 = s2;
}
__Alea.prototype.sample = function () {
  var t = 2091639 * this.s0 + this.c * 2.3283064365386963e-10; // 2^-32
  this.s0 = this.s1;
  this.s1 = this.s2;
  return (this.s2 = t - (this.c = t | 0));
};

function __Model(tickCount, elementCount, state) {
  this.bufSize = tickCount;
  this.outputs = [];
  for (var i = 0; i < elementCount; ++i) {
    this.outputs.push(new Float64Array(this.bufSize));
  }
  this.state = state;
}
__Model.prototype.getSketchValues = function (id) {
  var data = new Float64Array(this.bufSize);

  for (var i = 0; i < this.bufSize; ++i) {
    data[i] = this.computeSketch(this.state, null, i, id, NaN);
  }

  return data;
};
__Model.prototype.setInputByOffset = function (offset, value) {
  this.state.values[offset] = value;
  this.state.calc[offset] = 0;
};
__Model.prototype.getLookupValue = function (id, x) {
  return __lookup(this.state.lk[id], x);
};
__Model.prototype.getLookupValues = function (id, min, max, steps) {
  var data = new Float64Array(steps + 1);
  var lookup = this.state.lk[id];
  let dx = (max - min) / steps;
  for (var i = 0; i <= steps; ++i) {
    data[i] = __lookup(lookup, min + dx * i);
  }
  return data;
};
__Model.prototype.setDenseLookupById = function (id, table, min, max, steps) {
  this.state.lk[id] = __createDenseLookupFromSparse(table, min, max, steps);
};
__Model.prototype.setLookupById = function (id, table) {
  this.state.lk[id] = __createSparseLookup(table);
};
__Model.prototype.step = function () {
  for (var i = 0; i < this.state.res; ++i) {
    this.state.t += 1;
    this.calc();
  }
};
__Model.prototype.runToEnd = function () {
  if (this.state.t === 0) {
    this.calc();
  }

  while (this.state.t < this.bufSize) {
    this.step();
  }
};

function __delay(tick, resolution, closure, offset, defaultValue, legacy) {
  if (legacy) {
    var calcTick = tick - Math.round(offset * resolution);
    if (calcTick < 0) {
      if (defaultValue === null) {
        calcTick = 0;
      } else {
        return defaultValue;
      }
    }
    return closure(calcTick);
  } else {
    if (offset <= 0) {
      return defaultValue;
    } else {
      var calcTick = tick - Math.round(offset * resolution);
      return calcTick < 0 ? defaultValue : closure(calcTick);
    }
  }
}

function __denseLookup(table, min, max, step, x) {
  if (x <= min) {
    return table[0];
  } else if (x >= max) {
    return table[table.length - 1];
  } else {
    var delta = (x - min) / step;
    var left = Math.floor(delta);
    var right = Math.ceil(delta);
    if (left === right) {
      return table[left];
    } else {
      var frac = delta - left;
      return table[left] + frac * (table[right] - table[left]);
    }
  }
}

function __buildLookups(lookups, modelId) {
  var lookupMap = {};

  if (!lookups) {
    return lookupMap;
  }

  var modelLookups = lookups[modelId];

  if (modelLookups != null) {
    for (var key in modelLookups) {
      lookupMap[key] = __createSparseLookup(modelLookups[key]);
    }
  }

  return lookupMap;
}

function __buildSketches(sketches, modelId, containingModelId, submodelId) {
  var sketchMap = {};

  var modelSketches = sketches[modelId];
  if (modelSketches != null && modelSketches.elements != null) {
    for (var key in modelSketches.elements) {
      sketchMap[key] = modelSketches.elements[key];
    }
  }

  if (containingModelId != null && submodelId != null) {
    var containingModelSketches = sketches[containingModelId];
    if (
      containingModelSketches != null &&
      containingModelSketches.submodels != null
    ) {
      var overlaySketches = containingModelSketches.submodels[submodelId];
      if (overlaySketches != null) {
        for (var key in overlaySketches) {
          sketchMap[key] = overlaySketches[key];
        }
      }
    }
  }

  return sketchMap;
}

function __sparseLookup(xs, ys, x) {
  if (x <= xs[0]) {
    return ys[0];
  } else if (x >= xs[xs.length - 1]) {
    return ys[ys.length - 1];
  } else {
    var leftX = xs[0];
    for (var i = 1; i < xs.length; ++i) {
      var rightX = xs[i];
      if (x == rightX) {
        return ys[i];
      } else if (x < rightX) {
        var delta = ys[i] - ys[i - 1];
        var frac = (x - leftX) / (rightX - leftX);
        return ys[i - 1] + frac * delta;
      } else {
        leftX = rightX;
      }
    }
  }
}

function __createSparseLookup(table) {
  var vs = [];
  for (var key in table) {
    vs.push({ x: parseFloat(key), y: +table[key] });
  }
  vs.sort(function (a, b) {
    return a.x - b.x;
  });
  if (vs.length === 0) {
    vs.push({ x: 0, y: 0 });
  }
  var xs = new Float64Array(vs.length);
  var ys = new Float64Array(vs.length);
  vs.forEach(function (p, i) {
    xs[i] = p.x;
    ys[i] = p.y;
  });
  return { sparse: true, xs: xs, ys: ys };
}

function __createDenseLookupFromSparse(table, min, max, steps) {
  if (max <= min) {
    throw new Error("Lookup max must be strictly less than min.");
  }
  if (steps < 0) {
    throw new Error("Lookup steps must be greater than zero.");
  }
  var sparse = __createSparseLookup(table);
  let values = new Float64Array(steps + 1);
  let dx = (max - min) / steps;
  for (var i = 0; i <= steps; ++i) {
    values[i] = __sparseLookup(sparse.xs, sparse.ys, min + i * dx);
  }
  return { sparse: false, values: values, step: dx, min: min, max: max };
}

function __lookup(table, x) {
  if (table === undefined) {
    return 0;
  } else if (table.sparse) {
    return __sparseLookup(table.xs, table.ys, x);
  } else {
    return __denseLookup(table.values, table.min, table.max, table.step, x);
  }
}

function __sketchLookup(sketch, t, blankValue) {
  if (sketch === undefined) {
    return blankValue;
  }

  var index = t - sketch.start;
  if (index < 0 || index > sketch.values.length - 1) {
    return blankValue;
  }

  var leftIdx = Math.floor(index);
  var left = sketch.values[leftIdx];
  if (isNaN(left)) {
    return blankValue;
  }
  if (leftIdx === index) {
    return left;
  }
  var rightIdx = Math.ceil(index);
  if (rightIdx >= sketch.values.length) {
    return blankValue;
  }
  var right = sketch.values[rightIdx];
  if (isNaN(right)) {
    return blankValue;
  }
  return left + (index - leftIdx) * (right - left);
}

function __getTableColumn(tables, tableId, columnId) {
  if (!tables) return;
  var table = tables[tableId];
  if (!table) return;
  return table[columnId];
}

var TOLERANCE = 3 * EPSILON;

function __eq(a, b) {
  return a === b || Math.abs(a - b) < TOLERANCE;
}

function __leq(a, b) {
  return a < b || __eq(a, b);
}

function __geq(a, b) {
  return a > b || __eq(a, b);
}

function RunBuilder(project, modelName) {
  this.project = project;
  this.model = project.byName[modelName];
  this.modelConfigs = {};
  this.startTime = 0;
  this.stepCount = 100;
  this.resolution = 1;
}

RunBuilder.prototype.configureModel = function (modelName) {
  if (!this.modelConfigs[modelName]) {
    this.modelConfigs[modelName] = new ModelConfiguration(this, modelName);
  }

  return this.modelConfigs[modelName];
};

RunBuilder.prototype.setStartTime = function (startTime) {
  this.startTime = startTime;
  return this;
};

RunBuilder.prototype.setStepCount = function (stepCount) {
  this.stepCount = stepCount;
  return this;
};

RunBuilder.prototype.setResolution = function (resolution) {
  this.resolution = resolution;
  return this;
};

RunBuilder.prototype.start = function () {
  var sketches = {};
  var lookups = {};
  var tables = {};

  for (var name in this.project.byName) {
    var modelconstructor = this.project.byName[name];

    var config = this.configureModel(name);
    var modelId = null;

    for (var id in this.project.byId) {
      if (this.project.byId[id] === modelconstructor) {
        modelId = +id;
        break;
      }
    }

    sketches[modelId] = config.sketches;
    lookups[modelId] = config.lookups;
    tables[modelId] = config.tables;
  }

  return new this.model(
    this.startTime,
    this.resolution,
    this.stepCount,
    sketches,
    lookups,
    tables,
  );
};

RunBuilder.prototype.run = function () {
  var run = this.start();
  run.runToEnd();
  return run;
};

function ModelConfiguration(builder, modelName) {
  this.builder = builder;
  this.project = builder.project;
  var model = (this.model = this.project.byName[modelName]);
  this.sketches = { elements: {}, submodels: {} };
  this.lookups = {};
  var tables = (this.tables = {});

  for (var elementId in model.elementMetadata) {
    var element = model.elementMetadata[elementId];

    if (element.type === "DataTable") {
      tables[element.id] = {};
    }
  }

  this.rootPanel = model.getPanels().find(function (panel) {
    return panel.root === true;
  }).name;
}

function findElement(model, panel, element) {
  if (typeof element === "number") {
    return model.elementMetadata[element];
  } else {
    var id = model.getId(panel, element);
    if (id === undefined) {
      throw new Error('Could not find element "' + element + '".');
    }
    return model.elementMetadata[id];
  }
}

ModelConfiguration.prototype.setSketch = function (config) {
  var element = findElement(
    this.model,
    config.panel || this.rootPanel,
    config.element,
  );
  this.sketches.elements[element.id] = {
    start: config.start === undefined ? this.builder.startTime : config.start,
    values: config.values,
  };

  return this;
};

ModelConfiguration.prototype.setSubmodelSketch = function (config) {
  var element = findElement(
    this.model,
    config.panel || this.rootPanel,
    config.element,
  );

  if (this.sketches.submodels[element.id] == null) {
    this.sketches.submodels[element.id] = {};
  }

  var sketchMap = this.sketches.submodels[element.id];

  var targetModelBuilder = this.builder.configureModel(element.model);

  var targetElement = findElement(
    targetModelBuilder.model,
    config.targetPanel || targetModelBuilder.rootPanel,
    config.targetElement,
  );

  sketchMap[targetElement.id] = {
    start: config.start === undefined ? this.builder.startTime : config.start,
    values: config.values,
  };

  return this;
};

ModelConfiguration.prototype.setLookup = function (config) {
  var element = findElement(
    this.model,
    config.panel || this.rootPanel,
    config.element,
  );
  this.lookups[element.id] = config.table;

  return this;
};

ModelConfiguration.prototype.setDataset = function (config) {
  var table = {};

  var element = findElement(
    this.model,
    config.panel || this.rootPanel,
    config.element,
  );

  for (var columnName in config.columns) {
    var columnData = config.columns[columnName];

    var column = element.columns.find(function (col) {
      return col.name === columnName;
    });

    table[column.id] = {
      start:
        columnData.start === undefined
          ? this.builder.startTime
          : columnData.start,
      values: columnData.values,
    };
  }

  this.tables[element.id] = table;

  return this;
};
function _abs(x) {return Math.abs(x)};function _ceil(x) {return Math.ceil(x)};function _exp(x) {return Math.exp(x)};function _floor(x) {return Math.floor(x)};function _sqrt(x) {return Math.sqrt(x)};function _div(x, y, z) {return y == 0 ? z : x / y};function _frac(x) {return x - _int(x)};function _int(x) {return x < 0 ? Math.ceil(x) : Math.floor(x)};function _ln(x) {return x <= 0 ? 0 : Math.log(x)};function _log(x, base) {return x <= 0 ? 0 : (Math.log(x) / Math.log(base))};function _max(xs) {return xs.length === 0 ? 0 : Math.max.apply(Math, xs)};function _min(xs) {return xs.length === 0 ? 0 : Math.min.apply(Math, xs)};function _bound(x, min, max) {return x < min ? min : x > max ? max : x};function _power(x, e) {return Math.pow(x, e);};function _root(x, n) {if (x <= 0) {
  return 0;
} else {
  return Math.pow(Math.E, Math.log(x) / n);
}
};function _sign(x) {return x < 0 ? -1 : x > 0 ? 1 : 0};function _round2(x, places) {var y = places === 0 ? x : Math.pow(10, places) * x;
var i = Math.floor(y);
var f = y - i;

if (f === 0.5) {
  y = i % 2 === 0 ? i : i + 1;
} else {
  y = Math.round(y);
}

if (places === 0) {
  return y;
} else {
  return y / Math.pow(10, places);
}
};function _round(x, places) {if (places === 0) {
  return Math.round(x);
} else {
  var m = Math.pow(10, places);
  return Math.round(m * x) / m;
}
};function _random(state, max) {return state.sample() * max};function _step(tick, value, start) {return tick < start ? 0 : value};function _pulse(t, resolution, value, start, interval) {if (t < start) {
  return 0;
} else if (interval === 0) {
  return t === start ? value : 0;
} else {
  return (t - start) % Math.round(interval * resolution) === 0 ? value : 0;
}
};function _ramp(t, resolution, rate, start) {return t <= start ? 0 : (t - start) * (rate / resolution)};function _rand_bernoulli(state, p) {return state.sample() < p ? 1 : 0};function _rand_binomial(state, n, p) {if (n >= 40) {
  var np = n * p;
  if (np < 5 && p < 0.05) {
    return _rand_poisson(state, np);
  } else {
    return Math.min(
      n,
      Math.round(_rand_gaussian(state, np, Math.sqrt(np * (1 - p)))),
    );
  }
}

var x = 0;
for (var i = 0; i < n; ++i) {
  x += _rand_bernoulli(state, p);
}
return x;
};function _rand_discrete(state, min, max) {return min + Math.floor(state.sample() * ((max + 1) - min))};function _rand_uniform(state, min, max) {return min + (state.sample() * (max - min))};function _rand_exp(state, lambda) {return _rand_exp_percentile(lambda, state.sample())};function _rand_exp_percentile(lambda, perc) {return -Math.log(1 - perc) / lambda};function _rand_gaussian(state, mu, sigma) {do {
  var u1 = state.sample();
  var u2 = state.sample();
} while (u1 <= Number.MIN_VALUE);
var z0 = Math.sqrt(-2 * Math.log(u1)) * Math.cos(Math.PI * 2 * u2);
return z0 * sigma + mu;
};function _rand_gaussian_percentile(mu, sigma, q) {var x = 2 * q - 1;
var a = 0.140012;
var logtop = Math.log(1 - x * x);
var logterm = logtop / 2;
var piterm = 2 / (Math.PI * a) + logterm;
var inverf =
  _sign(x) * Math.sqrt(Math.sqrt(piterm * piterm - logtop / a) - piterm);

return mu + sigma * Math.SQRT2 * inverf;
};function _rand_pareto(state, xm, alpha) {return xm / Math.pow(1 - state.sample(), 1 / alpha)};function _rand_poisson(state, lambda) {return _rand_poisson_percentile(lambda, state.sample())};function _rand_poisson_percentile(lambda, q) {if (lambda === 0) return 0;

// Knuth-style naive simulation
if (lambda < 20) {
  // Cap Q to avoid infinite loops.
  if (q > 0.999999) {
    q = 0.999999;
  }
  var f = Math.exp(-lambda);
  var F = f;
  var k = 1;
  while (F < q) {
    f = (lambda / k) * f;
    F = F + f;
    k = k + 1;
  }
  return k - 1;
}

var q = _rand_gaussian_percentile(0, 1, q);
var t1 = q * Math.pow(lambda, 0.5);
var t2 = (q * q - 1) / 6;
var t3 = (Math.pow(lambda, -0.5) * (q - q * q * q)) / 72;

return Math.max(0, Math.floor(t1 + t2 + t3 + lambda + 0.5));
};function _rand_poisson_binomial(state, ps) {var x = 0,
  n = ps.length;
for (var i = 0; i < n; ++i) {
  x += _rand_bernoulli(state, ps[i]);
}
return x;
};function _rand_student(state, dof) {var w;
do {
  var u1 = 2 * state.sample() - 1;
  var u2 = 2 * state.sample() - 1;
} while ((w = u1 * u1 + u2 * u2) > 1);

return u1 * Math.sqrt((dof * (Math.exp((-2 / dof) * Math.log(w)) - 1)) / w);
};
function Model0(startTime, resolution, stepCount, sketches, lookups, tables, containingModelId, submodelId) {
  __Model.call(this, 1 + stepCount * resolution, 19, new ModelState0(startTime, resolution, stepCount, sketches, lookups, tables, containingModelId, submodelId));
}
Model0.prototype = Object.create(__Model.prototype);
Model0.prototype.getOffsetById = function getOffsetById(elementId) {
  switch (elementId) {
    case 2:
      return 0;
    case 3:
      return 1;
    case 4:
      return 2;
    case 5:
      return 3;
    case 6:
      return 4;
    case 7:
      return 5;
    case 8:
      return 6;
    case 9:
      return 7;
    case 10:
      return 8;
    case 11:
      return 9;
    case 12:
      return 10;
    case 13:
      return 11;
    case 14:
      return 12;
    case 19:
      return 13;
    case 20:
      return 14;
    case 21:
      return 15;
    case 22:
      return 16;
    case 24:
      return 17;
    case 25:
      return 18;
  }
};
Model0.prototype.getSubmodelById = function getSubmodelById(elementId) {
  switch (elementId) {
  }
};
Model0.prototype.computeSketch = function computeSketch($$, $o, $t, id, $blank) {
  var self = this;
  var $res = $$.res;
  var $dt = 1 / $res;
  var $v = $$.values;
  var $c = $$.calc;
  switch (id) {
    default:
      return __sketchLookup($$.sk[id], $t / $res, $blank);
  }
};
Model0.prototype.calc1 = function calc1() {
  var self = this;
  var $o = this.outputs;
  var $$ = this.state;
  var $res = $$.res;
  var $t = $$.t;
  var $dt = 1 / $res;
  var $v = $$.values;
  var $c = $$.calc;
  if ($t === 0 && $c[0] === 1) $v[0] = 100000;
  if ($t === 0 && $c[1] === 1) $v[1] = 50;
  if ($c[4] === 1) switch ($$.scenario) {
    case 32:
      $v[4] = 7;
      break;
    default:
      $v[4] = 10;
  }
  if ($c[9] === 1) switch ($$.scenario) {
    case 32:
      $v[9] = 0.6;
      break;
    case 33:
      $v[9] = 0.88;
      break;
    default:
      $v[9] = 0;
  }
  if ($c[10] === 1) switch ($$.scenario) {
    case 32:
      $v[10] = 0.99;
      break;
    case 33:
      $v[10] = 0.67;
      break;
    default:
      $v[10] = 0.9;
  }
  if ($c[11] === 1) switch ($$.scenario) {
    case 32:
      $v[11] = 0.9;
      break;
    case 33:
      $v[11] = 0.25;
      break;
    default:
      $v[11] = 0.2;
  }
  if ($c[12] === 1) $v[12] = 10;
  if ($c[15] === 1) switch ($$.scenario) {
    case 32:
      $v[15] = 10;
      break;
    default:
      $v[15] = 3;
  }
  if ($c[8] === 1) $v[8] = (1 - $v[10] * $v[9]) * $v[11];
  if ($c[16] === 1) switch ($$.scenario) {
    case 32:
      $v[16] = _div(0.00214, $v[4], 0);
      break;
    case 33:
      $v[16] = _div(0.00015, $v[4], 0);
      break;
    default:
      $v[16] = _div(0.015, $v[4], 0);
  }
  if ($c[6] === 1) $v[6] = $v[12] * $v[1];
  if ($c[13] === 1) $v[13] = $v[16] * $v[1];
  $$._3_acc -= $v[13] * $dt;
  $$._20_acc += $v[13] * $dt;
  if ($c[17] === 1) $v[17] = _div($v[1] * (1 - $v[16]), $v[4], 0);
  $$._3_acc -= $v[17] * $dt;
  $$._4_acc += $v[17] * $dt;
  if ($t === 0 && $c[2] === 1) $v[2] = $v[17];
  if ($t === 0 && $c[14] === 1) $v[14] = $v[13];
  if ($c[18] === 1) $v[18] = $v[1] + $v[2] + $v[0];
  if ($c[7] === 1) $v[7] = _div($v[0], $v[18], 0);
  if ($c[5] === 1) $v[5] = $v[7] * $v[6];
  if ($c[3] === 1) $v[3] = _min([_div($v[8] * $v[5], $v[15], 0), $v[0]]);
  $$._2_acc -= $v[3] * $dt;
  $$._3_acc += $v[3] * $dt;
  for (var i = 0; i < 19; ++i) $o[i][$t] = $v[i];
  $v[0] += $$._2_acc;
  $$._2_acc = 0;
  $v[1] += $$._3_acc;
  $$._3_acc = 0;
  $v[2] += $$._4_acc;
  $$._4_acc = 0;
  $v[14] += $$._20_acc;
  $$._20_acc = 0;
};
Model0.prototype.calc = function calc() {
  this.calc1();
};
function ModelState0(startTime, resolution, stepCount, sketches, lookups, tables, containingModelId, submodelId) {
  this._2_acc = 0;
  this._3_acc = 0;
  this._4_acc = 0;
  this._20_acc = 0;
  this.st = startTime;
  this.scenario = null;
  this.zt = -startTime * resolution;
  this.res = resolution;
  this.sk = __buildSketches(sketches, 0, containingModelId, submodelId);
  this.tables = tables[0];
  this.lk = __buildLookups(lookups, 0);
  this.t = 0;
  this.values = new Float64Array(19);
  this.calc = new Int8Array(19);
  for (var i = 0; i < this.calc.length; ++i) this.calc[i] = 1;
}
Model0.prototype.getValues = function getValues(panelName, elementName) {
  var offset = this.getOffsetById(Model0.getId(panelName, elementName));
  return offset === undefined ? undefined : this.outputs[offset];
};
Model0.prototype.setInput = function setInput(panelName, elementName, value) {
  var offset = this.getOffsetById(Model0.getId(panelName, elementName));
  if (offset !== undefined) {
    this.setInputByOffset(offset, value);
  }
};
Model0.getId = function getId(panelName, elementName) {
  switch (panelName) {
    case "infectious disease - working":
      switch (elementName) {
        case "Susceptible Population":
          return 2;
        case "Infected Population":
          return 3;
        case "Recovered Population":
          return 4;
        case "Becoming infected":
          return 5;
        case "Duration of infection":
          return 6;
        case "Number of susceptible meeting infected":
          return 7;
        case "Contacts with infected people":
          return 8;
        case "Probability of meeting susceptible person":
          return 9;
        case "Chance of becoming infected":
          return 10;
        case "Percent of population vaccinated":
          return 11;
        case "Vaccine effectiveness":
          return 12;
        case "Probability of being infected with no vaccine":
          return 13;
        case "Contact rate":
          return 14;
        case "Death":
          return 19;
        case "Deaths":
          return 20;
        case "incubation time":
          return 21;
        case "Mortality rate":
          return 22;
        case "Recovered":
          return 24;
        case "total population":
          return 25;
      }
      return;
  }
};
Model0.getPanels = function getPanels() {
  return [{
    name: "infectious disease - working",
    root: true
  }];
};
Model0.elementMetadata = {
  2: {
    id: 2,
    panel: "infectious disease - working",
    name: "Susceptible Population",
    type: "Stock"
  },
  3: {
    id: 3,
    panel: "infectious disease - working",
    name: "Infected Population",
    type: "Stock"
  },
  4: {
    id: 4,
    panel: "infectious disease - working",
    name: "Recovered Population",
    type: "Stock"
  },
  5: {
    id: 5,
    panel: "infectious disease - working",
    name: "Becoming infected",
    type: "Flow"
  },
  6: {
    id: 6,
    panel: "infectious disease - working",
    name: "Duration of infection",
    type: "Variable"
  },
  7: {
    id: 7,
    panel: "infectious disease - working",
    name: "Number of susceptible meeting infected",
    type: "Variable"
  },
  8: {
    id: 8,
    panel: "infectious disease - working",
    name: "Contacts with infected people",
    type: "Variable"
  },
  9: {
    id: 9,
    panel: "infectious disease - working",
    name: "Probability of meeting susceptible person",
    type: "Variable"
  },
  10: {
    id: 10,
    panel: "infectious disease - working",
    name: "Chance of becoming infected",
    type: "Variable"
  },
  11: {
    id: 11,
    panel: "infectious disease - working",
    name: "Percent of population vaccinated",
    type: "Variable"
  },
  12: {
    id: 12,
    panel: "infectious disease - working",
    name: "Vaccine effectiveness",
    type: "Variable"
  },
  13: {
    id: 13,
    panel: "infectious disease - working",
    name: "Probability of being infected with no vaccine",
    type: "Variable"
  },
  14: {
    id: 14,
    panel: "infectious disease - working",
    name: "Contact rate",
    type: "Variable"
  },
  19: {
    id: 19,
    panel: "infectious disease - working",
    name: "Death",
    type: "Flow"
  },
  20: {
    id: 20,
    panel: "infectious disease - working",
    name: "Deaths",
    type: "Stock"
  },
  21: {
    id: 21,
    panel: "infectious disease - working",
    name: "incubation time",
    type: "Variable"
  },
  22: {
    id: 22,
    panel: "infectious disease - working",
    name: "Mortality rate",
    type: "Variable"
  },
  24: {
    id: 24,
    panel: "infectious disease - working",
    name: "Recovered",
    type: "Flow"
  },
  25: {
    id: 25,
    panel: "infectious disease - working",
    name: "total population",
    type: "Variable"
  }
};
var Project = {
  byName: {
    "infectious disease - working": Model0
  },
  byId: {
    0: Model0
  },
  buildRun: function (modelName) {
    return new RunBuilder(Project, modelName);
  }
};

export default Project
